var _defs, _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIxperience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 489.9 489.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#D\xE9grad\xE9_sans_nom_28);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_28",
    x1: 79.85,
    y1: 530.92,
    x2: 410.05,
    y2: -41.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#027354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#029261"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "I - 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 489.9,
    height: 489.9,
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M695.26,311.17v259.7c0,8.56-2.87,15.52-8.66,20.81s-13.49,8-23.12,8c-9.26,0-16.83-2.63-22.58-8s-8.7-12.25-8.7-20.81V316.74l46.84-27a6.33,6.33,0,0,1,7.27.62l.29.25C692.39,295.76,695.26,302.61,695.26,311.17Z",
    transform: "translate(-393.86 -155.37)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M605.17,208.2h39.29a15.62,15.62,0,0,1,15.62,15.62v54.91a0,0,0,0,1,0,0H605.17a15.62,15.62,0,0,1-15.62-15.62V223.82A15.62,15.62,0,0,1,605.17,208.2Z",
    transform: "translate(-431.88 189.66) rotate(-30)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIxperience);
export default __webpack_public_path__ + "static/media/ixperience.526079627f4ea2a185bbdd1d012248c5.svg";
export { ForwardRef as ReactComponent };